import { Switch } from 'antd'
import clsx from 'clsx'
import { MarketPlaceType } from 'Modules'

import { AppAdmin } from 'api/app-admin'
import { useMarketPlaceAction } from 'hooks/marketplace/use-market-place-action'

const ButtonEnableMarketPlace = ({
  marketPlace,
  onChange,
}: {
  marketPlace: MarketPlaceType
  onChange?: () => void
}) => {
  const { loading, isContractManager, handleEnableMarketPlace } = useMarketPlaceAction({
    contractAddress: marketPlace?.contractAddress,
    onChange: async () => {
      await AppAdmin.applyTokenizeToMarketPlace({
        contractAddress: marketPlace.contractAddress,
      })
      if (onChange) onChange()
    },
  })

  return marketPlace?.contractAddress ? (
    <div>
      <Switch
        disabled={loading || !isContractManager}
        checked={marketPlace.marketplaceEnable}
        onChange={(checked) => {
          handleEnableMarketPlace(checked)
        }}
      />
      <span
        className={clsx('ml-1 text-success', {
          'text-success': marketPlace.marketplaceEnable,
        })}
      >
        {marketPlace.marketplaceEnable ? 'Enable' : 'Disable'}
      </span>
    </div>
  ) : null
}

export default ButtonEnableMarketPlace
